import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCursor3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCursor3"><Path d="M20.8272 8.58736L1.85547 1.85547L8.58736 20.8272L12.0002 17.4144L17.0002 22.4144L22.4144 17.0002L17.4144 12.0002L20.8272 8.58736Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCursor3;
